import { render } from "./UserAddresses.vue?vue&type=template&id=0631fab2"
import script from "./UserAddresses.vue?vue&type=script&lang=js"
export * from "./UserAddresses.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/sarayeghalam_omde-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__